import axios from 'axios'

const SILICONFLOW_BASE_URL = 'https://api.siliconflow.cn/v1'
const DEFAULT_MODEL = 'deepseek-ai/DeepSeek-V3'

const SYSTEM_PROMPT = `你是分步模板题目描述文案优化助手。请优化用户提供的题目描述，使其表达更清晰、专业、简洁，同时保持原意不变。

输出必须是可直接写入 Quill 编辑器的 HTML 字符串，严格遵循以下格式规范：
1. 若内容包含多个步骤，每步先用独立段落标注步骤号：<p>【第1步】</p>、<p>【第2步】</p>……
2. 步骤说明放在紧随其后的 <p> 段落中
3. 每句话中的关键操作、重点词使用红色加粗：<strong style="color: rgb(255, 0, 0);">重点内容</strong>
4. 括号内的补充说明、普通文字保持不加粗
5. 每个逻辑段落使用 <p>...</p> 包裹，段落之间不要换行符
6. 仅使用标签：p、strong（strong 必须带 style="color: rgb(255, 0, 0);"）
7. 不要使用 markdown，不要用代码块包裹，不要输出纯文本，直接输出 HTML 字符串

格式示例：
<p>【第1步】</p><p><strong style="color: rgb(255, 0, 0);">打开手机导航软件</strong>（高德、百度都可以）</p><p>【第2步】</p><p><strong style="color: rgb(255, 0, 0);">搜索店名关键部分</strong>(如好又多、联华等)</p><p>【第3步】</p><p>确认周边没有目标门店<strong style="color: rgb(255, 0, 0);">保存截图上传</strong></p>`

function getApiKey () {
  return window._env_ && window._env_.VUE_APP_SILICONFLOW_API_KEY
}

function getModel () {
  return (window._env_ && window._env_.VUE_APP_SILICONFLOW_MODEL) || DEFAULT_MODEL
}

function stripTags (html) {
  if (!html) return ''
  const div = document.createElement('div')
  div.innerHTML = html
  return (div.textContent || div.innerText || '').trim()
}

function sanitizeAiHtml (content) {
  if (!content) return ''
  let text = content.trim()
  const codeBlockMatch = text.match(/^```(?:html)?\s*([\s\S]*?)\s*```$/i)
  if (codeBlockMatch) {
    text = codeBlockMatch[1].trim()
  }
  return text
}

function buildUserMessage ({ content, context }) {
  const contextLine = context ? `题目标题：${stripTags(context)}\n` : ''
  return `${contextLine}请优化以下题目描述，保持上述 HTML 格式规范：\n${content}`
}

export function optimizeRichText ({ content, context }) {
  const apiKey = getApiKey()
  if (!apiKey) {
    return Promise.reject(new Error('未配置硅基流动 API Key'))
  }

  const plainText = stripTags(content)
  if (!plainText) {
    return Promise.reject(new Error('请先输入描述内容'))
  }

  return axios.post(
    `${SILICONFLOW_BASE_URL}/chat/completions`,
    {
      model: getModel(),
      messages: [
        { role: 'system', content: SYSTEM_PROMPT },
        { role: 'user', content: buildUserMessage({ content, context }) },
      ],
      temperature: 0.7,
      max_tokens: 2048,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${apiKey}`,
      },
    }
  ).then((response) => {
    const result = response.data && response.data.choices && response.data.choices[0]
    const optimized = result && result.message && result.message.content
    if (!optimized) {
      throw new Error('AI 返回内容为空')
    }
    return sanitizeAiHtml(optimized)
  }).catch((error) => {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message)
    }
    throw error
  })
}



// WEBPACK FOOTER //
// ./src/services/siliconflow.api.js